// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import React, { useContext } from "react";

export interface InvoiceDetailsPageContainerStyles {
    loadingOverlay?: LoadingOverlayProps;
    errorInfosBox?: InfosBoxProps;
}

export const invoiceDetailsPageContainerStyles: InvoiceDetailsPageContainerStyles = {
    errorInfosBox: { type: "error" },
};

const styles = invoiceDetailsPageContainerStyles;

const InvoiceDetailsPageContainer = ({ id }: WidgetProps) => {
    const invoiceDataView = useContext(InvoiceStateContext);

    return (
        <DataViewLoadingOverlay dataView={invoiceDataView} {...styles.loadingOverlay}>
            {invoiceDataView.errorStatusCode === 404 ? (
                <InfosBox {...styles.errorInfosBox}>{siteMessage("InvoiceHistory_Not_Found")}</InfosBox>
            ) : (
                <OrderLayout id={id} />
            )}
        </DataViewLoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Invoice History",
        allowedContexts: ["InvoiceDetailsPage"],
    },
};
export default widgetModule;
